// extracted by mini-css-extract-plugin
export default {"wrapper":"RemindIssueLaterDialog_wrapper__UZerF","info":"RemindIssueLaterDialog_info__zNPop"};